<template>
  <div class="timeline-item-card">
    <div class="level">
      <div class="level-left">
        <div class="timeline-item-action" v-if="action">
          <i class="material-icons" v-if="icons[action]">{{ icons[action] }}</i>
          <span>{{ actionTitle }}</span>
        </div>
      </div>

      <div class="level-right">
        <div class="timeline-item-distance" v-if="distance">
          <i class="material-icons">&#xE52E;</i>
          <span>{{ distance }}</span>
        </div>

        <div class="timeline-item-place" v-if="place">
          <i class="material-icons">&#xE55F;</i>
          <span>{{ place }}</span>
        </div>

        <div class="timeline-item-duration" v-if="duration">
          <i class="material-icons">&#xE192;</i>
          <span>{{ duration }}</span>
        </div>
      </div>
    </div>

    <div class="timeline-item-moments tags" v-if="moments && moments.length > 0 && !isPrediction">
      <span class="tag is-black" v-for="(moment, index) in moments" :key="index">
        <span>{{ momentDefinitions[moment.moment_definition_id].display_name }}</span>
        <span v-if="moment.duration" class="moment-duration">- {{ moment.duration }}</span>
      </span>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import icons from "utils/icons";
import { getEventKeypath } from "config/settings";

export default {
  name: "TimelineItemCard",
  props: {
    type: {
      type: String,
      required: false
    },
    action: {
      type: String,
      required: false
    },
    duration: {
      type: String,
      required: false
    },
    distance: {
      type: String,
      required: false
    },
    place: {
      type: String,
      required: false
    },
    moments: {
      type: Array,
      default: () => []
    },
    isPrediction: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      icons
    };
  },
  computed: {
    ...mapGetters("account", ["momentDefinitions"]),
    actionTitle() {
      if (this.action === "insufficient_data") {
        return this.type;
      }

      const keypath = getEventKeypath(this.action.toLowerCase());

      return keypath ? this.$t(keypath) : this.action;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~scss/utilities/initial-variables.scss";
@import "~scss/utilities/derived-variables.scss";

.timeline-item-card {
  padding: 0.625rem;
  border: 1px solid rgba($black, 0.08);
  border-radius: 2px;
  font-size: 0.875rem;
}

.timeline-item-moments {
  &.tags {
    &:last-child {
      margin-bottom: -0.25rem;
    }
  }

  .tag {
    height: auto;
    font-size: 0.875rem;
    line-height: 1.43;
    color: $white;
    background-color: #333;
    border-radius: 2px;
    padding: 0.1875rem 0.5rem;
    margin-bottom: 0.25rem;

    &:not(:last-child) {
      margin-right: 0.25rem;
    }

    .moment-duration {
      font-size: $size-small;
      color: rgba($white, 0.8);
      margin-left: 0.25rem;
    }
  }
}

.timeline-item-duration,
.timeline-item-place,
.timeline-item-distance {
  display: flex;

  &:not(first-child) {
    margin-left: 0.75rem;
  }

  &,
  i {
    font-size: 0.8125rem;
    line-height: 1.23;
    color: rgba($black, 0.64);
  }

  i {
    margin-right: 0.375rem;
  }
}

.timeline-item-place {
  span {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

.timeline-item-action {
  display: flex;

  &,
  i {
    color: rgba($black, 0.86);
    font-size: 0.875rem;
    line-height: 1.14;
  }

  i {
    margin-right: 0.375rem;
  }
}

.level {
  &:not(:last-child) {
    margin-bottom: 0.625rem;
  }
}
</style>
